<template>
  <div class="container bb_ad">
    <div class="bb_ad_title">
      <img class="bb_ad_title_img" src="../../../assets/images/activity/buycardgetcoupon/des.png" />
      <div class="bb_ad_title_time">活动有效期至2020.12.31</div>
    </div>
    <div class="bb_ad_deshuo">
      <img class="bb_ad_de" src="../../../assets/images/activity/buycardgetcoupon/des1.png" />
      <img class="bb_ad_de" src="../../../assets/images/activity/buycardgetcoupon/des2.png" />
      <img class="bb_ad_de" src="../../../assets/images/activity/buycardgetcoupon/des3.png" />
    </div>
    <div class="bb_ad_ming">活动说明</div>
    <div class="bb_ad_mingcont">
      <div>
        活动有效期截止到2020年12月31日<br />
        1. 开卡礼包的优惠券自开卡之日起有效期一年<br />
        <br />
        2. 【代金券】使用规则：<br />
        a.仅限会员本人使用；<br />
        b.可用于抵扣本人年费续费（不限使用张数）；<br />
        c.可用于抵扣本人预约费用（每次限使用1张）；<br />
        d.仅限会员身份有效期内使用，一旦会员过期代金券即作废；<br />
        <br />
        3. 【邀约券】使用规则：<br />
        a.老会员赠送非会员使用；<br />
        b.非会员包括：从未开过卡的新会员和会员已过期的用户；<br />
        c.仅限非会员用于开通会员使用，可多张叠加使用；<br />
        d.一经开卡成为会员，所有来自赠送的未被使用的邀约券都将自动作废；<br />
        e.使用邀约券开卡的用户，若券值大于会员年费，多出的券值将不予返还；<br />
        <br />
        4. 【会员退订】规则：<br />
        a.所有优惠券，一旦使用都将作废除；<br />
        b.会员开卡后，一旦产生任何使用行为，如：预约、退订、下场、赠送邀约券、使用代金券、领取等，都不可退卡；<br />
        c.会员账户中所有抵用券仅限会员身份有效期内使用，一旦会员过期，账户中所有优惠券都将自动作废（包括已经赠出的邀约券）；<br />
        d.通过邀约券开通会员后，如果退卡，邀请券即作废；<br />
        e.预约订单退订后，如有使用代金券，代金券将退还本人账户；<br />
        f.如会员使用代金券续费，一经退卡，代金券将不予退还。<br />
        <br />
        5.  该活动由上海合伽体育科技有限公司保留最终解释权。<br />
      </div>
    </div>
    <div class="bb_ad_btn">
      <div @click="bb_ad_btnback()">立即开通</div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return { }
    },
    created() { },
    watch: { },
    mounted() { 
      window.scrollTo(0, 0)
    },
    methods: {
     bb_ad_btnback(){
       this.$router.push({
         name:'vip'
       })
     }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .bb_ad{
    width: 100%;padding-bottom: 210*@vm_base;
    background:linear-gradient(100deg,rgba(23,23,29,1) 0%,rgba(115,118,135,1) 42%,rgba(19,21,27,1) 100%);
    .bb_ad_title{
      width: 100%;
      position: relative;
      .bb_ad_title_img{
        width: 100%;
      }
      .bb_ad_title_time{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        font-size: 24*@vm_base;
        text-align: center;
        color: #FFFFFF;
        font-weight: 400;
        margin-bottom: 40*@vm_base;
      }
    }
    .bb_ad_deshuo{
      width: 100%;
      padding: 0 32*@vm_base;
      .bb_ad_de{
        width: 100%;
        margin-bottom: 40*@vm_base;
      }
    }
    .bb_ad_ming{
      width: 100%;
      font-size: 36*@vm_base;
      color: #FFFFFF;
      height: 116*@vm_base;
      line-height: 116*@vm_base;
      text-align: center;
    }
    .bb_ad_mingcont{
      width: 100%;
      padding: 0 32*@vm_base;
      div{
        background:rgba(42,43,52,1);
        border-radius:12*@vm_base;
        font-size: 24*@vm_base;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 44*@vm_base;
        padding: 40*@vm_base;
      }
    }
    .bb_ad_btn{
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      background:linear-gradient(180deg,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%);
      padding: 30*@vm_base 32*@vm_base 30*@vm_base 32*@vm_base;
      border: none;
      div{
        width: 100%;
        height: 90*@vm_base;
        line-height: 90*@vm_base;
        text-align: center;
        font-size: 32*@vm_base;
        font-weight: 500;
        color: #FFFFFF;
        background:rgba(42,43,52,1);
        border-radius:12*@vm_base;
        border:1*@vm_base solid rgba(221,221,221,0.5);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/activity/buyCardGetCoupon/buyCardGetCoupon.vue